import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'vtr-container-collapsible',
	templateUrl: './container-collapsible.component.html',
	styleUrls: ['./container-collapsible.component.scss'],
	exportAs: 'containerCollapisble',
})
export class ContainerCollapsibleComponent extends BaseComponent {
	@Input() cardTitle: string;
	@Input() isCollapsed = true;
	@Input() allowCollapse = true;
	@Input() theme = 'dark';
	@Input() collapseLinkId: string;
	@Output() toggle = new EventEmitter();
	@Input() metricsParent: string;
	@Input() tabIndex = 1;
	@Input() headerLevel: number | null = null;
	constructor(private sanitized: DomSanitizer) {
		super();
	}
	public onToggle() {
		this.isCollapsed = !this.isCollapsed;
		this.toggle.emit(this.isCollapsed);
	}
	public transform(value) {
		return this.sanitized.bypassSecurityTrustHtml(value);
	}
}
